/* tslint:disable */
/* eslint-disable */
/**
 * crm-campaigns
 * crm-campaigns
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CampaignStats } from './CampaignStats';
import {
    CampaignStatsFromJSON,
    CampaignStatsFromJSONTyped,
    CampaignStatsToJSON,
} from './CampaignStats';

/**
 * 
 * @export
 * @interface GetCampaignStats200Response
 */
export interface GetCampaignStats200Response {
    /**
     * 
     * @type {CampaignStats}
     * @memberof GetCampaignStats200Response
     */
    data?: CampaignStats;
}

/**
 * Check if a given object implements the GetCampaignStats200Response interface.
 */
export function instanceOfGetCampaignStats200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetCampaignStats200ResponseFromJSON(json: any): GetCampaignStats200Response {
    return GetCampaignStats200ResponseFromJSONTyped(json, false);
}

export function GetCampaignStats200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCampaignStats200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CampaignStatsFromJSON(json['data']),
    };
}

export function GetCampaignStats200ResponseToJSON(value?: GetCampaignStats200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CampaignStatsToJSON(value.data),
    };
}

